// extracted by mini-css-extract-plugin
var _1 = "N6UqHRSXsVY0wrsNqvXX";
var _2 = "N6UqHRSXsVY0wrsNqvXX";
export { _1 as "submit-button", _2 as "submitButton" }
